/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListOwnAffiliateMembershipsOptions,
  ListOwnAffiliateMembershipsResponses,
} from '../types/ListOwnAffiliateMemberships'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Returns only the authenticated user's memberships and reusable codes, including inactive programs.
 * @summary List your affiliate memberships
 * {@link /v1/affiliate_referrers/self}
 */
export function listOwnAffiliateMemberships<ThrowOnError extends boolean = true>(
  options: Options<ListOwnAffiliateMembershipsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListOwnAffiliateMembershipsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/affiliate_referrers/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListOwnAffiliateMembershipsResponses, ThrowOnError>>,
  )
}
